import { EVENT_SOURCE } from '@app/modules/core/constants/amplitude.constants';
import { ReservationType } from '@user-history/entities/user-history-item';
import { AssistanceReservationInfo } from '@shared/travel-assistance/entities/booking-assistance';

export enum CrossSellingAction {
  NAVIGATE = 'NAVIGATE',
  EMIT_TYPE = 'EMIT_TYPE'
}

export type CrossSellingReservationItem = Readonly<{
  TypeCrossSellingItem: ReservationType;
  ReservationType: ReservationType;
  UrlParams: string;
  Translations: CrossSellingTranslations;
  Image: CrossSellingImage;
  Action: CrossSellingAction;
  Source: EVENT_SOURCE;
  AssistanceInfo: AssistanceReservationInfo;
  Currency: string;
}>;

export type CrossSellingTranslations = Readonly<{
  Title: string;
  Offer: string;
  SeeOffer: string;
  PercentageOffer: string;
}>;

export type CrossSellingImage = Readonly<{
  Path: string;
  ImageUrl: string;
  LogoUrl: string;
}>;
